import { useGetPatientOrderHistoryInfinite } from "@/api/generated";
import { useAuthStore } from "@/store";

export function useOrders() {
  const { isAuthInitialized } = useAuthStore();
  return useGetPatientOrderHistoryInfinite(
    { page_size: 10 },
    {
      query: {
        enabled: isAuthInitialized,
        initialPageParam: null,
        getNextPageParam: (page) =>
          page.has_next_page ? page.next_cursor : undefined,
        select: (data) => ({
          ...data,
          orders: data.pages.flatMap((page) => page.orders ?? []),
        }),
      },
    },
  );
}
